import request from '../request';

const baseUrl = request.getBaseUrl();

// const baseUrl = 'http://10.238.122.73:8878';
const server = {
  // 查询结算账户状态
  getEpaySettleAccountStatus(params) {
    return request.fetch(
      `/payment/epayAcountApply/getEpayAccountStatus`,
      params
    );
  },
  // 查询结算账户申请信息-详情
  getEpaySettleAccountApplyInfo(params) {
    return request.fetch(
      `/payment/epayAcountApply/getEpaySettleAccountApplyInfo`,
      params
    );
  },
  // 查询结算账户申请信息-编辑
  getEpaySettleAccountApplyEdit(params) {
    return request.fetch(
      `/payment/epayAcountApply/getEpaySettleAccountApplyEdit`,
      params
    );
  },
  // 提交结算账户申请信息
  addEpaySettleAccountApply(params) {
    return request.post(
      '/payment/epayAcountApply/addEpaySettleAccountApply',
      params
    );
  },
  // 查询银行行号-分页
  queryBankPage(params) {
    return request.post('/payment/epayAcountApply/queryBankPage', params);
  },
  // 获取结算账户-Ukey收件人信息图片验证码
  getEpaySettleAccountUkeyImageCode(params) {
    return request.fetch(
      '/payment/epayAcountApply/getEpaySettleAccountUkeyImageCode',
      params
    );
  },
  // 发送结算账户-Ukey收件人信息短信
  sendEpaySettleAccountUkeySMS(params) {
    return request.post(
      '/payment/epayAcountApply/sendEpaySettleAccountUkeySMS',
      params
    );
  },
  // 预览-获取图片完整地址
  getSupplierLicence(params) {
    return request.fetch('/payment/oss/getSupplierLicence', params);
  },
  // 验证公司营业执照信息完整性
  checkBusinessLicenseInfoIsIntact(params) {
    return request.post(
      '/payment/epayAcountApply/checkBusinessLicenseInfoIsIntact',
      params
    );
  },
  //自动注销待激活企业账户
  autoCancelEpayAccountTemp(params) {
    return request.post('/payment/epayAcountApply/autoCancelEpayAccountTemp', params);
  },


  // 查询字典值 企业性质（economicProperty）/法人证件类型（certificateType）/币种（currency）/资信等级（creditGrade）/机构类型（organizationType）
  queryDictItemList(params) {
    return request.fetch('/user-center/dict/queryDictItemList', params);
  },
  // 根据国家编码查询地区，如果是中国返回的是省的list
  queryAreaByCountryCode(params) {
    return request.post(`/user-center/area/queryAreaByCountryCode`, params);
  },
  // 根据省返回市
  getCityByAreaId(params) {
    return request.post(`/user-center/area/getCityByAreaId`, params);
  },
  // 根据市返回区县
  getDistrictByCityId(params) {
    return request.post(`/user-center/area/getDistrictByCityId`, params);
  },
  // 上传开户申请附件
  uploadPayCenterFile: `${baseUrl}/payment/epayAcountApply/uploadPayCenterFile`,
  // 预览
  // queryPayCenterFile: `${baseUrl}/payment/epayAcountApply/getPayCenterFile`,
  getPayCenterFile(params) {
    return request.fetch('/payment/epayAcountApply/getPayCenterFile', params);
  },
  // 验证结算账户-支付用户邮箱唯一
  checkEpaySettleAccountUserEmailUnique(params) {
    return request.fetch(
      '/payment/epayAcountApply/checkEpaySettleAccountUserEmailUnique',
      params
    );
  },
  // 验证结算账户-支付用户支付平台登录名唯一
  checkEpaySettleAccountUserLoginAccountUnique(params) {
    return request.fetch(
      '/payment/epayAcountApply/checkEpaySettleAccountUserLoginAccountUnique',
      params
    );
  },
  // 验证结算账户-支付用户手机唯一
  checkEpaySettleAccountUserMobileUnique(params) {
    return request.fetch(
      '/payment/epayAcountApply/checkEpaySettleAccountUserMobileUnique',
      params
    );
  },
  // 验证结算账户-支付用户证件号码唯一
  checkEpaySettleAccountUserIDNumberUnique(params) {
    return request.fetch(
      '/payment/epayAcountApply/checkEpaySettleAccountUserIDNumberUnique',
      params
    );
  },
  // 结算账户增加申请人（授权书）附件
  addEpaySettleAccountApplicantAttach(params) {
    return request.post(
      `/payment/epayAcountApply/addEpaySettleAccountApplicantAttach`,
      params
    );
  },
  // 操作用户-申请记录
  queryAccountUserApplyOperatePage(params) {
    return request.post(
      '/payment/epayAcountUserApply/queryAccountUserApplyOperatePage',
      params
    );
  },
  // 操作用户-列表
  queryAccountUserList(params) {
    return request.fetch(
      '/payment/epayAcountUserApply/queryAccountUserList',
      params
    );
  },
  // 操作用户-查询申请人信息
  getEpayAccountApplicant(params) {
    return request.fetch(
      '/payment/epayAcountApply/getEpayAccountApplicant',
      params
    );
  },
  // 操作用户-查询Ukey收件地址
  getEpayAccountUkey(params) {
    return request.fetch('/payment/epayAcountApply/getEpayAccountUkey', params);
  },
  // 操作用户-支付用户邮箱唯一
  checkEpayAccountUserEmailUnique(params) {
    return request.post(
      '/payment/epayAcountUserApply/checkEpayAccountUserEmailUnique',
      params
    );
  },
  // 操作用户-支付用户支付平台登录名唯一
  checkEpayAccountUserLoginAccountUnique(params) {
    return request.post(
      '/payment/epayAcountUserApply/checkEpayAccountUserLoginAccountUnique',
      params
    );
  },
  // 操作用户-支付用户手机唯一
  checkEpayAccountUserMobileUnique(params) {
    return request.post(
      '/payment/epayAcountUserApply/checkEpayAccountUserMobileUnique',
      params
    );
  },
  // 操作用户-支付用户证件号码唯一
  checkEpayAccountUserIDNumberUnique(params) {
    return request.post(
      '/payment/epayAcountUserApply/checkEpayAccountUserIDNumberUnique',
      params
    );
  },
  // 操作用户-注销用户和补办ukey时查询有效的操作用户列表
  getAccountValidUserList(params) {
    return request.fetch(
      '/payment/epayAcountUserApply/getAccountValidUserList',
      params
    );
  },
  // 操作用户-根据用户ID查询用户
  getEpayAccountUser(params) {
    return request.fetch(
      '/payment/epayAcountUserApply/getEpayAccountUser',
      params
    );
  },
  // 操作用户-新增操作用户
  addAccountUserApply(params) {
    return request.post(
      '/payment/epayAcountUserApply/addAccountUserApply',
      params
    );
  },
  // 操作用户-新增操作用户权限验证
  addEpayAccountUserRoleCheck(params) {
    return request.post(
      '/payment/epayAcountUserApply/addEpayAccountUserRoleCheck',
      params
    );
  },
  // 操作用户-修改操作用户
  modifyEpayAccountUser(params) {
    return request.post(
      '/payment/epayAcountUserApply/modifyEpayAccountUser',
      params
    );
  },
  // 操作用户-修改操作用户权限验证
  modifyEpayAccountUserRoleCheck(params) {
    return request.post(
      '/payment/epayAcountUserApply/modifyEpayAccountUserRoleCheck',
      params
    );
  },
  // 操作用户-补办Ukey
  reissueUkeyEpayAccountUser(params) {
    return request.post(
      '/payment/epayAcountUserApply/reissueUkeyEpayAccountUser',
      params
    );
  },
  // 操作用户-补办Ukey，验证是否有未完成的证书操作
  reissueUkeyCheckNotFinishCredentials(params) {
    return request.fetch(
      '/payment/epayAcountUserApply/reissueUkeyCheckNotFinishCredentials',
      params
    );
  },
  // 操作用户-注销用户
  cancelEpayAccountUser(params) {
    return request.post(
      '/payment/epayAcountUserApply/cancelEpayAccountUser',
      params
    );
  },
  // 操作用户-注销操作用户验证
  cancelEpayAccountUserCheck(params) {
    return request.post(
      '/payment/epayAcountUserApply/cancelEpayAccountUserCheck',
      params
    );
  },
  // 操作用户-注销企业账户
  cancelEpayAccount(params) {
    return request.post('/payment/epayAcountApply/cancelEpayAccount', params);
  },
  // 操作用户-注销企业账户验证
  checkCancelEpayAccount(params) {
    return request.post(
      '/payment/epayAcountApply/checkCancelEpayAccount',
      params
    );
  },
  // 操作用户-注销企业专户
  cancelEpayAccountSub(params) {
    return request.post(
      '/payment/epayAcountApply/cancelEpayAccountSub',
      params
    );
  },
  // 操作用户-注销企业专户验证
  checkCancelEpayAccountSub(params) {
    return request.post(
      '/payment/epayAcountApply/checkCancelEpayAccountSub',
      params
    );
  },
  // 企业信息变更-列表
  queryModifyPage(params) {
    return request.post(
      '/payment/epayAcountModify/queryModifyPage',
      params
    );
  },
  // 企业信息变更-详情
  modifyDetail(params) {
    return request.post(
      '/payment/epayAcountModify/modifyDetail',
      params
    );
  },
  //企业信息变更-重新发起变更
  reApplyModify(params) {
    return request.post(
      '/payment/epayAcountModify/reApplyModify',
      params
    );
  },



};
export default server;
